<div class="password-dialog">
  <form class="password-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="password-caption">
      <h3>Change Password</h3>
    </div>
    <div class="password-credentials">
      @if (showCurrent) {
        <div class="password-current">
          <app-password [formGroup]="formGroup" [meta]="metaCurrent"></app-password>
        </div>
      }
      <div class="password-password">
        <app-password [formGroup]="formGroup" [meta]="metaPassword"></app-password>
      </div>
      <div class="password-confirm">
        <app-password [formGroup]="formGroup" [meta]="metaConfirm"></app-password>
      </div>
    </div>
    <div class="password-error">
      <app-error [message]="errMsg"></app-error>
    </div>
    <div class="password-actions">
      <button type="submit" class="button" mat-button [disabled]="!formGroup.valid">Submit</button>
      <button type="button" class="button" mat-button mat-dialog-close>Cancel</button>
    </div>
  </form>
</div>
